module.exports = __webpack_public_path__ + "static/media/banner_sicbo-half.fbb214be.png";